module.exports = __webpack_public_path__ + "static/img/qianyue3.a30a053.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qianyue3.png
// module id = hIyf
// module chunks = 1